import { configureStore } from '@reduxjs/toolkit'

//From Slice
import cartReducer from './cartSlice/cartSlice'
import userReducer from './userSlice/userSlice'
import promotionSlice from './promotionSlice/promotionSlice'

import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, cartReducer)
const persistedUserReducer = persistReducer(persistConfig, userReducer)

export const store = configureStore({
  reducer: {
    cart: persistedReducer,
    user: persistedUserReducer,
    promotion: promotionSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export const persistor = persistStore(store)
